import { Component } from '@angular/core';
import { GlobalService } from 'src/app/Services/global.service';
import { Router,ActivatedRoute} from '@angular/router';
import Swal from 'sweetalert2';

declare var $:any;

@Component({
  selector: 'app-user-list',
  templateUrl: './user-list.component.html',
  styleUrls: ['./user-list.component.scss']
})
export class UserListComponent {

public dataListing:any=[];
  public AllData:any=[];
  public loading:boolean = true;
  public loginDetail:any =[];
  public totalCount: number = 0;
  public p:any = 1;
  public pageLimit:any = 10;
  public previousLabel:any='';
  public nextLabel:any='';
  public searchKey:any='';
  public searchKey1:any='';
  public confirmStatus: boolean = false;
  public Ids:any=''; 
  public CurrentUrl:any=this.router.url;
  public sortType:any='desc';

  constructor(public router: Router, public service: GlobalService) { 
    this.loginDetail = JSON.parse(localStorage.getItem('gra_login') || "{}");   
      if(localStorage.getItem('gra_pogeno')) {
      this.p=localStorage.getItem('gra_pogeno');
      localStorage.removeItem('gra_pogeno');
    } 
    this.getDetail(this.p);
   }

  ngOnInit(): void {
  }

     getDetail(page:any){
      var type:any='';
      if(this.CurrentUrl=='/creators'){
        type="Individual Creator";
      } else if(this.CurrentUrl=='/organisations'){
        type="Organisation";
      } else{
        type="Customer";
      }      
      var detail={
        "type":type,
        "search": this.searchKey,
        sortBy:'emailVerifiedTime',
        sortOrder:this.sortType

      }; 
      this.service.PostApis(detail,'/user-list?page='+page).subscribe(((response:any)=>{
        if(response.success ==1) {  
          this.AllData=response.data;;
          this.dataListing= response.data.record;  
          this.totalCount = response.data.total; 
          this.loading=false;
        } else {
          this.dataListing=[];  
          this.AllData=[];
          this.totalCount =  response.data.total; 
          this.loading=false;
        }
      }), (error) => { this.loading =false; });
    }
 
    redirect(item:any,type:any){
      this.Ids =item._id;
       localStorage.setItem('gra_pogeno',this.p);
      localStorage.setItem('gra_EditData',JSON.stringify(item));
        if(type ==1){
          if(item.user_role_type ==4){
            this.router.navigate(['/user-detail']);
          } else if(item.user_role_type ==2){
            this.router.navigate(['/organisation-detail']);
          } else {
            this.router.navigate(['/creator-detail']);           
          }
        } else {
          if(item.is_collaborator && item.user_role_type !=4){
            this.service.dangerAlert('Please Cancel your subscription first');
          } else{
          Swal.fire({
            title: 'Are you sure?',
            text: "You won't be able to revert this!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, delete it!',
          }).then((result:any) => {
            let statusType: number = 0;
            if (result.isConfirmed) {
             this.delete();
            }
          });
        }
        }
      }
    
      delete(){
        var url='/user-delete';
        this.service.PostApis({'id':this.Ids},url).subscribe(((response:any)=>{
          if(response.success ==1) {  
            this.loading=false;
            this.p=1;
            this.getDetail(this.p);
          } else {
            this.loading=false;
          }
        }), (error) => { this.loading =false; });
    
      } 


    updateStatus(event:any,data:any){
      var jj :any = event.target.checked;
      Swal.fire({
        title: 'Are you sure?',
       text: "You want to change the status?",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, change it!',
      }).then((result:any) => {
        if (result.isConfirmed) {
          this.update(data);
        } else {
          this.getDetail(this.p);
        }
      });
  
    }
  
    update(data:any){
      var url='/user-update';
      var js:any='';
      if(data.status != 'Active'){
        js='Active';
      } else {
        js='In-Active';
      }
      var detail={
        "status": js,
        "id": data._id
    }
      this.service.PostApis(detail,url).subscribe(((response:any)=>{
        if(response.success ==1){         
          this.loading=false; 
          this.p=1; 
          this.getDetail(this.p);
        } else {
          this.service.dangerAlert(response.message);
          this.loading=false;
        }
      }), (error:any) => {
        this.loading=false;
      });
    }

    reset(){
      this.p=1;
      this.searchKey='';
      this.searchKey1='';
      this.getDetail(this.p);
    }
}
